/**
 * Serwis API: zmiana metody platnosci zakonczonej transakcji (tylko w OTWARTEJ zmianie).
 *
 * Trasy (kontrakt KONTRAKT-PLATNOSC 2026-09-11):
 *  - GET /api/kasa-bank/zmiana/transakcje?location_id=<id>
 *  - GET /api/transakcje/<id>/platnosc/mozliwosci
 *  - PUT /api/transakcje/<id>/platnosc  {nowa_forma, powod, potwierdzam_fiskalny?}
 *
 * Bledy NIE sa opakowywane w new Error(...) - interceptor api.js dokleja
 * err.data (cale cialo odpowiedzi), a UI czyta err.data.komunikat / error_code.
 */

import api from './api';

export const FORMY_PLATNOSCI = ['gotowka', 'karta', 'blik', 'przelew'];

export const FORMA_LABELS = {
  gotowka: 'gotówka',
  karta: 'karta',
  blik: 'BLIK',
  przelew: 'przelew',
  kupon: 'kupon',
  dzielona: 'dzielona',
  mieszana: 'mieszana'
};

export const formaLabel = (forma) => FORMA_LABELS[forma] || forma || '-';

/**
 * Backend w tym module zwraca albo {success, data: {...}} (konwencja kasa-bank),
 * albo goly obiekt wg kontraktu. Czytamy oba warianty.
 */
const odpakuj = (body) => {
  if (body && typeof body === 'object' && 'success' in body && 'data' in body) {
    return body.data;
  }
  return body;
};

export const platnosciService = {
  /**
   * Transakcje otwartej zmiany biezacego uzytkownika w lokalizacji.
   * @returns {{ transakcje: Array, zmiana: Object|null, komunikat: string|null }}
   */
  transakcjeZmiany: async (locationId) => {
    const response = await api.get('kasa-bank/zmiana/transakcje', {
      params: locationId ? { location_id: locationId } : {}
    });
    const d = odpakuj(response.data) || {};
    const transakcje = Array.isArray(d) ? d : (d.transakcje || d.items || []);
    return {
      transakcje,
      zmiana: Array.isArray(d) ? null : (d.zmiana || null),
      komunikat: Array.isArray(d) ? null : (d.komunikat || null)
    };
  },

  /**
   * Czy dana transakcja moze miec zmieniona platnosc (przycisk w POS).
   * @returns {{ mozna_zmienic: boolean, powod_blokady: string|null, formy: string[], obecna: string, fiskalizacja: boolean }}
   */
  mozliwosci: async (id) => {
    const response = await api.get(`transakcje/${id}/platnosc/mozliwosci`);
    const d = odpakuj(response.data) || {};
    return {
      mozna_zmienic: !!d.mozna_zmienic,
      powod_blokady: d.powod_blokady || null,
      formy: Array.isArray(d.formy) && d.formy.length ? d.formy : FORMY_PLATNOSCI,
      obecna: d.obecna || null,
      fiskalizacja: !!d.fiskalizacja
    };
  },

  /**
   * Zmiana platnosci. Rzuca err z err.data = {error, komunikat, error_code}.
   * @returns {{ id, numer_paragonu, stara_forma, nowa_forma, kwota, kp: 'zaktualizowany'|'dopisany', audit_id }}
   */
  zmien: async (id, { nowa_forma, powod, potwierdzam_fiskalny = false }) => {
    const payload = { nowa_forma, powod };
    if (potwierdzam_fiskalny) payload.potwierdzam_fiskalny = true;
    const response = await api.put(`transakcje/${id}/platnosc`, payload);
    return odpakuj(response.data);
  }
};

/** Komunikat bledu dla UI: najpierw komunikat biznesowy z backendu, potem message. */
export const komunikatBledu = (err, fallback = 'Nie udało się zmienić płatności') =>
  err?.data?.komunikat || err?.response?.data?.komunikat || err?.message || fallback;

export default platnosciService;
